export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? "brand-compact" : ""}`}>
      <img src="/icon.svg" alt="" />
      <span>KungKung</span>
    </div>
  );
}
